import React from 'react';

const Website = ({ className }) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <circle cx='12' cy='12' r='12' fill='#667085' />
            <g clipPath='url(#clip0_579_86613)'>
                <path
                    d='M18.6666 12C18.6666 15.6819 15.6819 18.6667 12 18.6667M18.6666 12C18.6666 8.31814 15.6819 5.33337 12 5.33337M18.6666 12H5.33331M12 18.6667C8.31808 18.6667 5.33331 15.6819 5.33331 12M12 18.6667C10.2881 16.8693 9.33331 14.4822 9.33331 12C9.33331 9.51787 10.2881 7.13081 12 5.33337M12 18.6667C13.7118 16.8693 14.6666 14.4822 14.6666 12C14.6666 9.51787 13.7118 7.13081 12 5.33337M5.33331 12C5.33331 8.31814 8.31808 5.33337 12 5.33337'
                    stroke='white'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_579_86613'>
                    <rect width='16' height='16' fill='white' transform='translate(4 4)' />
                </clipPath>
            </defs>
        </svg>
    );
};

export { Website };
